import React, { useState } from 'react'
import { Table } from '../../components/Table/Table'
import { view_icon } from '../../assets/imgs';
import { useLocation, useNavigate } from 'react-router-dom';
import { admin_list, property_list } from '../redux/api/dummyJson';
import { useLazyPropertyContentsQuery } from '../redux/api/api';

const PropertyContent = () => {
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [pageno, setPageno] = useState(1);
    const [pagecount, setPagecount] = useState("");

    const rolePermissions = JSON.parse(localStorage.getItem('permissions'))

    console.log('mapo', list)



    const columns = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{row.index + 1}</p>;
                },
            },

            {
                Header: "Name",
                accessor: "propName",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Action",
                accessor: "",
                Cell: ({ value, row }) => {
                    return (
                        <React.Fragment>
                            <div className="d-flex ac-jc">
                                {rolePermissions?.includes('CAN-VIEW-MASTER') &&
                                    <button
                                        onClick={() => navigate("/view-property-content", { state: { id: row.original.propertyStatus == "1" ? 1 : row.original.propertyStatus == "2" ? 2 : row.original.propertyStatus == "3" ? 3 : row.original.propertyStatus == "4" ? 4 : "", type: "view" } })}
                                        className="cust-btn "
                                    >
                                        <img src={view_icon} alt="" className="mx-2 edit-btn " />
                                    </button>}
                            </div>
                        </React.Fragment>
                    );
                },
            },
        ],
        []
    );


    return (
        <div className="dashRightView home_section" >
            <div className='d-flex ac-jb'>
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
                    Masters - Property Content
                </h2>
            </div>
            <div>
                <Table columns={columns} data={property_list} setPageno={setPageno} pagecount={pagecount} show={false} />
            </div>


        </div>
    )
}


export default PropertyContent